module.exports = new __parcel__URL__("hammerstorm.47d53067.png").toString();